module.exports = __webpack_public_path__ + "static/media/avatars_male_10.59c34936.png";